import React from 'react';
import { Check, Info } from 'lucide-react';
import { SITE_CONFIG } from '../config/siteConfig';
const included = ['Una página de una sola navegación', 'Hasta seis secciones principales', 'Hasta diez servicios, o hasta veinte productos iniciales', 'Una reseña o testimonio', 'Una ubicación', 'Un número de WhatsApp', 'Enlaces a redes sociales', 'Dos rondas de revisión', 'Dominio y hosting por un año', 'Entrega estimada en siete días hábiles después de recibir toda la información'];
const extras = ['Más de veinte productos', 'Carga masiva de inventario', 'Varias sucursales', 'Sistemas de reserva avanzados', 'Pago en línea', 'Integraciones externas', 'Desarrollo de plataformas', 'Usuarios y roles', 'Paneles administrativos complejos', 'Redacción extensa', 'Fotografía profesional', 'Producción de video', 'Traducciones', 'Cambios adicionales después de las dos rondas', 'Funcionalidades personalizadas fuera del paquete'];
export function PackageLimitsSection() {
  return <section className="bg-[#050511] py-16 md:py-20" aria-labelledby="limites-title" data-id="element-1047">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1048">
        <div className="rounded-2xl border border-white/10 bg-[#101022] p-6 md:p-8" data-id="element-1049">
          <div className="max-w-3xl" data-id="element-1050">
            <div className="flex items-center gap-2 text-[#20d6e8]" data-id="element-1051">
              <Info className="h-5 w-5" data-id="element-1052" />
              <p className="text-sm font-semibold uppercase tracking-[0.14em]" data-id="element-1053">
                Alcance transparente
              </p>
            </div>
            <h2 id="limites-title" className="mt-4 text-2xl font-bold text-white md:text-3xl" data-id="element-1054">
              Para entregar rápido, trabajamos con un alcance claro.
            </h2>
            <p className="mt-3 text-[#a9a9ba]" data-id="element-1055">
              Paquete de {SITE_CONFIG.product.price}. Las funcionalidades
              especiales se cotizan según su alcance.
            </p>
          </div>

          <div className="mt-7 grid gap-6 lg:grid-cols-2" data-id="element-1056">
            <div data-id="element-1057">
              <h3 className="text-lg font-semibold text-white" data-id="element-1058">Incluye:</h3>
              <ul className="mt-4 grid gap-2.5" data-id="element-1059">
                {included.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-[#d2d2dc]" data-id="element-1060">
                    <Check className="mt-0.5 h-4 w-4 flex-none text-[#25d366]" data-id="element-1061" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="rounded-xl border border-[#e92a88]/20 bg-[#e92a88]/5 p-6" data-id="element-1062">
              <h3 className="text-lg font-semibold text-white" data-id="element-1063">
                Extras que se cotizan aparte:
              </h3>
              <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-1064">
                {extras.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-[#c7c7d2]" data-id="element-1065">
                    <span className="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-[#e92a88]" data-id="element-1066" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}